import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { TestId } from "pax-ui/core";
import {
  Icon,
  IconExclamationTriangle,
  IconInfoCircle,
  IconRegistryService,
  IconX,
  PaxIcon,
} from "pax-ui/icons";
import { UnreachableCaseError } from "ts-essentials";

import { Markdown } from "../markdown";

@Component({
  standalone: true,
  selector: "pax-notification",
  templateUrl: "./notification.html",
  imports: [CommonModule, Icon, Markdown],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("fadeInOut", [
      state(
        "void",
        style({
          opacity: 0,
        }),
      ),
      transition("void <=> *", animate("500ms ease-in-out")),
    ]),
  ],
})
export class Notification {
  @Input({ required: true })
  notificationMessages: NotificationMessage[] | undefined;

  @Output()
  delete = new EventEmitter<number>();

  notificationMessageTestId = TestId.NOTIFICATION_MESSAGE;

  readonly iconClose: PaxIcon = IconX;
  readonly iconInfo: PaxIcon = IconInfoCircle;
  readonly iconHighRisk: PaxIcon = IconExclamationTriangle;

  Severity = Severity;

  constructor(readonly _iconRegistryService: IconRegistryService) {
    _iconRegistryService.registerIcons([
      this.iconClose,
      this.iconInfo,
      this.iconHighRisk,
    ]);
  }

  getIconName(severity: Severity) {
    switch (severity) {
      case Severity.INFO:
        return this.iconInfo.name;
      case Severity.WARNING:
      case Severity.ERROR:
        return this.iconHighRisk.name;
      default:
        throw new UnreachableCaseError(severity);
    }
  }

  deleteNotificationMessage(id: number) {
    this.delete.emit(id);
  }
}
export interface NotificationMessage {
  id: number;
  severity: Severity;
  text: string | undefined;
  markdown: string | undefined;
}

export enum Severity {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}
